'use es6';

import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
const ProfileCardWrapper = ({
  id,
  children,
  dataTestId
}) => {
  const {
    compact
  } = useResponsiveProps({
    compact: {
      xs: true,
      sm: true,
      md: true,
      lg: true,
      xl: false
    }
  });
  return /*#__PURE__*/_jsx(CardWrapper, {
    compact: compact,
    "data-test-id": dataTestId,
    id: id,
    marginBlockEnd: "400",
    children: children
  });
};
export default ProfileCardWrapper;